import { render } from "./OfferedCourses.vue?vue&type=template&id=1343c5c2&scoped=true&ts=true"
import script from "./OfferedCourses.vue?vue&type=script&lang=ts"
export * from "./OfferedCourses.vue?vue&type=script&lang=ts"

import "./OfferedCourses.vue?vue&type=style&index=0&id=1343c5c2&scoped=true&lang=css"

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1343c5c2"]])

export default __exports__